import 'whatwg-fetch'
import Vue from 'vue'
import PrismicVue from 'prismic-vue'
import Buefy from 'buefy'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import App from '@/app.vue'

import router from './router'

import i18n from '@/helpers/i18n'
import GlobalErrorHandler from '@/helpers/global-error-handler'
import { VUE_APP_CMS_ENDPOINT_URL, VUE_APP_CMS_ENDPOINT_ACCESS_TOKEN } from '@/helpers/env'

import cmsService from '@/services/cms'
import AuthentificationService from '@/services/authentification'
import BusinessService from '@/services/business'

import VueConsts from '@/plugins/consts'
import Sluggify from '@/plugins/sluggify'
import MediaQuery from '@/plugins/media-query'
import { PrismicText } from '@/plugins/prismic'
import Format from '@/plugins/format'
import { ToastNotification } from '@/plugins/toast-notification'
import graphqlHelpers from './plugins/graphql-helpers'
import './directives/focus'

import Apollo from '@/graphql/vue-apollo'

import Loader from '@/components/generic/loader'

library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('s-loader', Loader)

Vue.use(Sluggify)
Vue.use(VueConsts)
Vue.use(Buefy, { defaultIconPack: 'fas', defaultProgrammaticPromise: true })
Vue.use(PrismicVue, {
  endpoint: VUE_APP_CMS_ENDPOINT_URL,
  apiOptions: { accessToken: VUE_APP_CMS_ENDPOINT_ACCESS_TOKEN },
  linkResolver: cmsService.linkResolver
})
Vue.use(PrismicText)
Vue.use(MediaQuery)
Vue.use(Format)
Vue.use(ToastNotification)
Vue.use(graphqlHelpers)

Vue.config.productionTip = false
Vue.config.errorHandler = GlobalErrorHandler

window.addEventListener('error', function(e) {
  GlobalErrorHandler(e)
})

AuthentificationService.loadLocalState().then(() => {
  BusinessService.loadLocalState().then(() => {
    new Vue({
      router,
      i18n: i18n.instance(),
      apolloProvider: Apollo.instance,
      render: h => h(App)
    }).$mount('#app')
  })
})
